export default __webpack_public_path__ + "static/lbwk-9f90670b85def8f921e2ff133af5b501.png";